export enum TransferSourceType {
  InBound = 'InBound',
  OutBound = 'OutBound',
}
